import images from "../images/webappwebp.webp"
import iphone from "../images/ios.webp"
import android from "../images/android.webp"
import hybrid from "../images/hybrid.webp"
const dataArray = [
  {
    logoText: "Web",
    // imageSrc1: web,
    imageSrc2:images ,
    textBelowImage: "A Web App",
  },
  {
    logoText: "iOS",
    // imageSrc1: 'image1.png',
    imageSrc2: iphone,
    textBelowImage: "An Iphone/ ipad App",
  },
  {
    logoText: "ANDROID MOBILE",
    // imageSrc1: 'image1.png',
    imageSrc2: android,
    textBelowImage: "An Android Phone / Tablet app",
  },
  {
    logoText: "Hybrid mobile",
    // imageSrc1: 'image1.png',
    imageSrc2: hybrid,
    textBelowImage: "An IOS and an Android app",
  },
];
export default dataArray;
